import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MultilevelMenuComponent } from './multilevel-menu.component'
import { SharedModule } from '../shared/shared.module'
import { RouterModule } from '@angular/router';
import { ItemMenuComponent } from './item-menu/item-menu.component';
import { ItemContentComponent } from './item-content/item-content.component'
import { PipesModule } from '../../pipes/pipes.module';


@NgModule({
  declarations: [MultilevelMenuComponent, ItemMenuComponent, ItemContentComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    PipesModule
  ],
  exports: [MultilevelMenuComponent]
})
export class MultilevelMenuModule { }
